/** Fetch an authenticated backend URL as a blob and trigger a filename download. */
export async function downloadAuthedFile(path, filename, onError) {
  const token = localStorage.getItem("db_token");
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error(`status ${res.status}`);
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1500);
  } catch (e) {
    if (onError) onError(e);
  }
}
